package pl.michal_cyran.brand_hub.subpages.tutoring.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridAutoRows
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H2 // Zmiana z H1 na H2
import org.jetbrains.compose.web.dom.P  // Zmiana z H3 na P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.components.widgets.MarkedText
import pl.michal_cyran.brand_hub.subpages.tutoring.composables.TestimonialCard

@Composable
fun TutoringTestimonials(
    modifier: Modifier = Modifier
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(1.cssRem)
    ) {

        // ZMIANA SEO: H1 zastąpiony H2 w celu zachowania logicznej hierarchii dokumentu HTML
        H2 {
            Text("Opinie moich uczniów i rodziców")
        }

        // ZMIANA SEO: Zamiana H3 na P dla prawidłowej struktury nagłówków
        P {
            Text("Zobacz, jak oceniane są moje korepetycje z matematyki i informatyki.")
        }

        SimpleGrid(
            numColumns(1, md = 3),
            modifier = Modifier
                .display(DisplayStyle.Grid)
                .gridAutoRows { size(1.fr) }
                .gap(16.px)
                .id("testimonials"),
        ) {
            TestimonialCard(
                text = "\"Michał bardzo fajnie prowadzi zajecia, zawsze odpisuje i widac ze zalezy mu na jego uczniach, polecam!!!\"",
                author = "Julka",
                description = ", uczennica 1 klasy liceum",
                index = 0,
            )

            TestimonialCard(
                text = "\"Idealne przygotowanie pod kątem matury! Świetna atmosfera, empatyczna osoba i duża wyrozumiałość dla ucznia.\"",
                author = "Aleksandra",
                description = ", maturzystka",
                index = 1,
            )

            TestimonialCard(
                text = "\"Polecam z całego serca. Bardzo zadowoleni z lekcji. Córka napisała egzamin 8 klasisty na 100%!\"",
                author = "Pavel",
                description = ", rodzic uczennicy 8 klasy",
                index = 2,
            )
        }

        Span {
            Text("Wszystkie opinie są ")
            MarkedText("autentyczne")
            Text(" i pochodzą z mojego profilu na portalu Superprof.pl.")
            Br()
            Link(
                path = "https://www.superprof.pl/poprawka-matury-tym-razem-miej-pewnosc-zdasz-absolwent-uniwersytetu-jagiellonskiego.html"
            ) {
                MarkedText("Sprawdź mój profil na Superprof")
            }
        }
    }
}